const global = require ("../common/global.js")
// const axios = require('../utils/axios.js') 
const axios = require ("axios")
    
   const  request_data = (module_name, url, methods, params,result) => {
        if (global.dev_env_conf == "test") {
             axios_send(module_name, url, methods, params,"test",result);
        } else if (global.dev_env_conf == "dev") {
            axios_send(module_name, url, methods, params,"dev",result);
        }
    }
    const  axios_request_body = (module_name, url, methods, params,result) => {
        if (global.dev_env_conf == "test") {
            axios_send_body(module_name, url, methods, params,"test",result);
        } else if (global.dev_env_conf == "dev") {
            axios_send_body(module_name, url, methods, params,"dev",result);
        }
    }
    const axios_send = (module_name, url, methods, params,dev_env_conf,result) => {
       let basic_url = global.module_name[dev_env_conf][module_name];
       let token = global.token;
       if(window.localStorage.getItem("token")){
            token = window.localStorage.getItem("token");
        }
        // alert("该系统正在升级中，一切为测试数据");
    //    let token = this.$local.token;
    //    if(!token){
    //        //配置测试token,用户为老杨
    //        token = global.token;
    //    }
        try {
            // 发送 请求
             axios(
                {
                   url: url,
                   method: methods,
                   baseURL: basic_url,
                //    headers: {'X-Requested-With': 'XMLHttpRequest'},
                    params: params,
                   headers:{
                    //    Bearer
                       'Authorization' :`Bearer ${token}`
                   }
                 }
            ).then(response=>{
                // console.log(response.data);
                  result(response.data);
            });

        } catch (error) {
            console.log(error)
               let p = new Promise((reslove,reject) => {
                   reject('网络连接失败:'+error)
            })

        }
    }
    const axios_send_body = (module_name, url, methods, params,dev_env_conf,result) => {
        let basic_url = global.module_name[dev_env_conf][module_name];
        let token = global.token;
        if(window.localStorage.getItem("token")){
             token = window.localStorage.getItem("token");
         }
         // alert("该系统正在升级中，一切为测试数据");
     //    let token = this.$local.token;
     //    if(!token){
     //        //配置测试token,用户为老杨
     //        token = global.token;
     //    }
         try {
             // 发送 请求
              axios(
                 {
                    url: url,
                    method: methods,
                    baseURL: basic_url,
                 //    headers: {'X-Requested-With': 'XMLHttpRequest'},
                     data: params,
                    headers:{
                     //    Bearer
                        'Authorization' :`Bearer ${token}`
                    }
                  }
             ).then(response=>{
                 // console.log(response)
                   result(response.data);
             });
 
         } catch (error) {
             console.log(error)
                let p = new Promise((reslove,reject) => {
                    reject('网络连接失败:'+error)
             })
 
         }
     }
    module.exports = {
        request_data,
        axios_request_body
    }